import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { AdminClientPageImages } from './AdminClientPageImages';

const monoFont = "'IBM Plex Mono', monospace";
const C = {
  fg: 'rgba(247,246,242,0.85)',
  fgMuted: 'rgba(247,246,242,0.45)',
};

interface ClientPage {
  id: string;
  name: string;
  slug: string;
}

interface AdminClientPageEditProps {
  pageId: string;
  onBack: () => void;
}

export function AdminClientPageEdit({ pageId, onBack }: AdminClientPageEditProps) {
  const [page, setPage] = useState<ClientPage | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const { data } = await supabase.rpc('get_client_pages_safe');
      const found = (data as ClientPage[] || []).find(p => p.id === pageId);
      setPage(found || null);
      setLoading(false);
    };
    load();
  }, [pageId]);

  if (loading || !page) {
    return <p style={{ fontFamily: monoFont, color: C.fgMuted }}>Carregando...</p>;
  }

  return (
    <div>
      {/* Back button */}
      <button
        onClick={onBack}
        className="flex items-center gap-2 mb-6"
        style={{
          fontFamily: monoFont, fontSize: 12, fontWeight: 300,
          color: C.fgMuted, background: 'none', border: 'none', cursor: 'pointer',
          transition: 'color 0.15s ease',
        }}
        onMouseEnter={e => { e.currentTarget.style.color = C.fg; }}
        onMouseLeave={e => { e.currentTarget.style.color = C.fgMuted; }}
      >
        ← VOLTAR
      </button>

      {/* Page name */}
      <h2
        className="uppercase mb-2"
        style={{ fontFamily: monoFont, fontSize: 16, fontWeight: 300, color: '#F7F6F2' }}
      >
        {page.name}
      </h2>
      <p className="mb-6" style={{ fontFamily: monoFont, fontSize: 12, color: 'rgba(247,246,242,0.4)' }}>
        /aprovacao/{page.slug}
      </p>

      {/* Images */}
      <AdminClientPageImages pageId={page.id} pageSlug={page.slug} />
    </div>
  );
}
